import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation DeleteBrandBrief($id: ID!) {
    deleteBrandBrief(id: $id) {
      id
    }
  }
`;

interface Result {
  id: ID;
}

export const deleteBrandBrief = async (id: ID): Promise<Result | undefined> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: { id },
  });

  return getSingleProp<Result>(result.data);
};
